const locale = {
	back_to_dashboard: 'Back to dashboard',
	page_doesnt_exist: 'Sorry but we could not find the page you are looking for',
	something_went_wrong: 'Sorry, something went wrong!',
};

export default locale;
